/**
 * Deepest `offset` the agency person lists accept (`/natural-persons`,
 * `/legal-persons`, `/persons`; DB-876 — a deeper offset is an expensive scan
 * and is rejected with HTTP 400).
 */
export var MAX_LIST_OFFSET = 10000;
/**
 * True when more records exist but the next page would start beyond the
 * backend's offset limit — the pager must stop and ask for a narrower search.
 *
 * @param offset offset of the current page
 * @param pageSize records per page
 * @param totalCount total records of the search
 * @param maxOffset deepest offset the endpoint accepts, undefined = unlimited
 * @returns whether paging further is blocked by the limit
 */
export var isPagingCapped = function (offset, pageSize, totalCount, maxOffset) {
    if (maxOffset === undefined)
        return false;
    var nextOffset = offset + pageSize;
    return nextOffset < totalCount && nextOffset > maxOffset;
};
